import { EDIT, OWNER } from '../../constants/fieldPermissions';
import { BASE_LAYERS, HARVEST_IDS } from '../../constants/mapLayerIds';

/**
 * Extracts the harvest layers from the seasonObject passed
 * and considers the users field permissions
 * @param {Object} seasonObject
 * @param {String} fieldPermission
 * @return {Object}
 */
export function extractHarvestLayers(seasonObject, fieldPermission) {

  if (
    seasonObject.harvestYear &&
    (fieldPermission === OWNER || fieldPermission === EDIT)
  ) {
    return HARVEST_IDS.reduce(
      (result, id) => ({
        ...result,
        [id]: {},
      }),
      { [BASE_LAYERS.COMBINE_ELEVATION]: {} }
    );
  }
  return {};
}
